import React, {useEffect} from "react";
import {Colors} from "../../../assets/colors/Colors";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import {FormProvider, useForm, useFormContext, useWatch} from "react-hook-form";
import Tooltip from "@mui/material/Tooltip";
import {modalCRUDService} from "../../../services/modalCRUDService";
import GeneradorDirecciones from "../../../components/ComponentesFormularios/GeneradorDireccionesForm";
import {useDispatch, useSelector} from "react-redux";
import {GlobalConstants} from "../../../data/GlobalConstants";
import {clientesService} from "../../../services/apiClientes";
import {HeaderClientInformation} from "./FormCRUD";
import {
  classResponsiveForm, classResponsiveFormWidthHeader,
  classResponsiveFormDoubleWidth, optionsEstados, ERRORFIELDREQUIRED, optionsYesNo, ERROREMAILFIELDREQUIRED
} from "../../../data/ConstantForm";
import NestedSelectForm from "../../../components/ComponentesFormularios/NestedSelectForm";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import {isEmpty, isObject} from "../../../util/is";
import {CalendarForm} from "../../../components/ComponentesFormularios/CalendarForm";
import {dateToStringFormat} from "../../../util/functions";


const ZonaPostal = ({isEditing}) => {

  const { control, setValue, formState: { errors } } = useFormContext();

  const idCiudad = useWatch({
    control,
    name: "idCiudad"
  });

  useEffect(() => {
    setValue("idZonaPostal", isObject(idCiudad) ? idCiudad?.id : idCiudad);
  }, [idCiudad])


  return(
    <InputForm inputProps={{control}} readOnly={true} disabled={!isEditing} identificador="idZonaPostal" label="Zona Postal"
               placeholder="Ej: 57" type="text" required={false} className={`${classResponsiveForm}`}
               customError={errors.idZonaPostal ? ERRORFIELDREQUIRED : null}/>
  )

}

const MotivoEstado = ({isEditing}) => {

  const { control, setValue, formState: { errors } } = useFormContext();
  const generalServicesState = useSelector( state => state.generalServices )

  const motivoInactivacion = useWatch({
    control,
    name: "motivoInactivacion"
  })

  useEffect(() => {

    if(!isEmpty(motivoInactivacion)){
      setValue("estado", 0);
    }

  }, [motivoInactivacion])

  return(
    <>
      <SelectForm inputProps={{control}} disabled={!isEditing} identificador="motivoInactivacion" label="Motivo Inactivación"
                  options={generalServicesState?.arrMotivosInactivacionClientes}  required={false} className={`${classResponsiveForm}`}
                  customError={errors.motivoInactivacion ? ERRORFIELDREQUIRED : null}/>


      <RadioButtonForm inputProps={{control}} disabled={!isEditing || !isEmpty(motivoInactivacion)} identificador="estado" options={optionsEstados} required={true}
                       defaultValue="1" label="Estado" className={`${classResponsiveForm}`}
                       customError={errors.estado ? ERRORFIELDREQUIRED : null}/>
    </>
  )

}

const FormPuntoVentaCRUD = ({isEditing, isAddMode, properties}) => {

    const { data, codTercero, idModal, infoCli, function: executeFunction } = properties;
    const dispatch = useDispatch();
    const generalServicesState = useSelector( state => state.generalServices )
    const authState = useSelector( state => state.auth )
    const { idUsuario } = authState;


    const methods = useForm({defaultValues: {...data,
        dtIngreso: isEmpty(data?.dtIngreso) ? dateToStringFormat(new Date()) : data?.dtIngreso,
        txCorreo: isEmpty(data?.correo) ? infoCli?.correo : data?.correo,
        celular: isEmpty(data?.celular) ? infoCli?.celular : data?.celular,
        telefono: isEmpty(data?.telefono) ? infoCli?.telFijo : data?.telefono,
        direccion: isEmpty(data?.direccion) ? infoCli?.direccion : data?.direccion,
        txBarrio: isEmpty(data?.txBarrio) ? infoCli?.barrio : data?.txBarrio,
        idCiudad: isEmpty(data?.idCiudad) ? infoCli?.idCiudad : data?.idCiudad,
        idDepartamento: isEmpty(data?.idDepartamento) ? infoCli?.idDepartamento : data?.idDepartamento,
        idPais: isEmpty(data?.idPais) ? infoCli?.idPais : data?.idPais
      }});

    const { handleSubmit, formState: { errors }, control } = methods;


    const onSuccessSubmit = data => {

        data['idTer'] = codTercero;
        data['usr'] = idUsuario;
        data['ac'] = isAddMode ? 'C' : isEditing ? 'A' : 'LOCK';
        data.idCiudad = isObject(data?.idCiudad) ? data.idCiudad.id : data.idCiudad;
        data.idDepartamento = isObject(data?.idDepartamento) ? data.idDepartamento.id : data.idDepartamento;
        data.idPais = isObject(data?.idPais) ? data.idPais.id : data.idPais;

        clientesService.setCrudPuntoVenta(data).then(
            response => {

                const { status, msg, data: datos, sync } = response;

                if (status) {
                    if(datos?.idmsg === 200){

                        if(isAddMode && isEditing){
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });
                            executeFunction({newState: sync})
                        }
                        else{
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });
                            executeFunction({newState: sync, item: data})
                        }

                        modalCRUDService.clear("modalPuntoVenta");
                    }
                    else{
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: datos?.txmsg } });
                    }

                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
                }


            },
            error => {

                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });

            }
        )

    }

    const onErrorSubmit = errors => {
        console.log(errors)
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Faltan campos obligatorios, por favor válida la información' } });
    }

    return(
        <FormProvider {...methods} >
            <form className="container mx-0 px-0 w-100 mw-100">

            <div className="d-flex justify-content-between align-items-center px-0">

                <HeaderClientInformation infoCli={infoCli}/>

                <div className="d-flex align-items-center">
                    { isEditing &&
                    <Tooltip title="Guardar" aria-label="guardar">
                        <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                           className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-check fa-2x"/>
                        </a>
                    </Tooltip>
                    }
                    <Tooltip title="Cancelar" aria-label="cancelar">
                        <a onClick={() => {modalCRUDService.clear(idModal)}} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                            <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"/>
                        </a>
                    </Tooltip>
                </div>
            </div>

            <div className="mx-2 mt-2 mb-2 text-center text-muted content-divider divider-form">
                <span/>
            </div>

            <div className="row mx-0 px-0 mt-4 justify-content-between align-items-center">


                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="idPtoVenta" label="Cod. Punto Venta"
                               placeholder="Automatico" readOnly={true} type="text" required={false} className={`${classResponsiveForm}`}
                               customError={errors.idPtoVenta ? ERRORFIELDREQUIRED : null}/>

                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="nbPuntoVenta" label="Cod. Int. Punto Venta"
                               placeholder="Automatico" readOnly={true} type="text" required={false} className={`${classResponsiveForm}`}
                               customError={errors.nbPuntoVenta ? ERRORFIELDREQUIRED : null}/>

                    <InputForm inputProps={{control}} disabled={!isEditing} identificador="idErp" label="Cod. Erp"
                               placeholder="Automatico" readOnly={true} type="text" required={false} className={`${classResponsiveForm}`}
                               customError={errors.idErp ? ERRORFIELDREQUIRED : null}/>

                    <MotivoEstado isEditing={isEditing}/>

            </div>


            <div className="mx-2 my-2 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Información Básica</span>
            </div>

            <div className="row mx-0 px-0 mb-2">


                <InputForm inputProps={{control}} disabled={!isEditing} identificador="txNegocio" label="Nombre Negocio"
                           placeholder="Ej: Tienda Pepito Perez" type="text" required={true} className={`px-2 col-8`}
                           customError={errors.txNegocio ? ERRORFIELDREQUIRED : null}/>

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="idMatriculaMercantil" label="Matricula Mercantil"
                           placeholder="Ej: 12345" type="text" required={false} className={classResponsiveForm}
                           customError={errors.idMatriculaMercantil ? ERRORFIELDREQUIRED : null}/>

                <CalendarForm inputProps={{control}} disabled={true} identificador="dtIngreso"  label="Fecha Ingreso"
                            required={true} className={`${classResponsiveForm}`} customError={errors.dtIngreso ? ERRORFIELDREQUIRED : null} />


            </div>


            <div className="mx-2 my-2 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Localización</span>
            </div>

            <div className="row mx-0 px-0 mb-2 mt-3">

                <SelectFormVirtualize inputProps={{control}} isEditing={!isEditing} identificador="idPais" label="País" required={true}
                                  className={classResponsiveFormWidthHeader} options={generalServicesState?.arrPaises}
                                      customError={errors.idPais ? ERRORFIELDREQUIRED : null}/>

                <NestedSelectVirtualizeForm isEditing={!isEditing} keyIdentificador="idDepartamento" label="Departamento" required={true}
                                  className={classResponsiveFormWidthHeader} options={generalServicesState?.arrDepartamentos}
                                  customError={errors.idDepartamento ? ERRORFIELDREQUIRED : null} keyFatherValue="idPais"/>

                <NestedSelectVirtualizeForm isEditing={!isEditing} keyIdentificador="idCiudad" label="Ciudad" required={true}
                                  className={classResponsiveFormWidthHeader} options={generalServicesState?.arrCiudades}
                                  keyFatherValue="idDepartamento" customError={errors.idCiudad ? ERRORFIELDREQUIRED : null}/>

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="txBarrio" label="Barrio"
                           placeholder="Ej: Andes" type="text" required={true} className={`${classResponsiveFormWidthHeader}`}
                           customError={errors.txBarrio ? ERRORFIELDREQUIRED : null}/>

                <GeneradorDirecciones props={{control}} className={`w-100`} identificador="direccion" required={true}
                                      label="Dirección" customError={errors.direccion ? ERRORFIELDREQUIRED : null}   />

                <ZonaPostal isEditing={isEditing}/>

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="idDane" label="Sector Dane"
                           placeholder="Ej: 12345" type="text" required={false} className={`${classResponsiveForm}`}
                           customError={errors.idDane ? ERRORFIELDREQUIRED : null}/>

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="txEstrato" label="Estrato"
                           placeholder="Ej: 4" type="number" required={false} className={`${classResponsiveForm}`}
                           customError={errors.txEstrato ? ERRORFIELDREQUIRED : null}/>


                <InputForm inputProps={{control}} disabled={!isEditing} identificador="latitud" label="Latitud"
                           placeholder="Ej: -7.123213" type="text" required={false} className={`${classResponsiveForm}`}
                           customError={errors.latitud ? ERRORFIELDREQUIRED : null}/>


                <InputForm inputProps={{control}} disabled={!isEditing} identificador="longitud" label="Longitud"
                           placeholder="Ej: 7.1231231" type="text" required={false} className={`${classResponsiveForm}`}
                           customError={errors.longitud ? ERRORFIELDREQUIRED : null}/>


            </div>

            <div className="mx-2 my-2 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Datos de contacto</span>
            </div>

            <div className="row mx-0 px-0 mt-3 mb-2">

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="telefono" label="Teléfono Fijo"
                           placeholder="Ej: 6987877" type="number" required={false} className={`${classResponsiveForm}`}
                           customError={errors.telefono ? "Longitud min 6 y max 10" : null} rules={{minLength: 6, maxLength: 10}}/>

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="celular" label="Teléfono Celular"
                           placeholder="Ej: 3006789875" type="number" required={false} className={`${classResponsiveForm}`}
                           customError={errors.celular ? "Longitud min 10 y max 11" : null} rules={{minLength: 10, maxLength: 11}}/>

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="txCorreo" label="Correo Electrónico"
                           placeholder="Ej: test@hotmail.com" type="text" required={false} className={`${classResponsiveFormDoubleWidth}`}
                           customError={errors.txCorreo ? ERROREMAILFIELDREQUIRED : null} rules={{pattern: { value: /\S+@\S+\.\S+/}}}/>

                <InputForm inputProps={{control}} disabled={!isEditing} identificador="txCorreoFelam" label="Copia de recepción doc. electrónicos"
                           placeholder="Ej: test@hotmail.com" type="text" required={false} className={`${classResponsiveFormDoubleWidth}`}
                           customError={errors.txCorreoFelam ? ERROREMAILFIELDREQUIRED : null} rules={{pattern: { value: /\S+@\S+\.\S+/}}}/>

            </div>

            <div className="mx-2 my-2 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{color: Colors.COLOR_SKY_THEME}}>Parametros de reserva y facturación</span>
            </div>

            <div className="row mx-0 px-0 mt-3">

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="excentoIva" options={optionsYesNo} required={true}
                                 defaultValue="N" label="Excento IVA" className={`${classResponsiveForm}`}
                                 customError={errors.excentoIva ? ERRORFIELDREQUIRED : null}/>

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="reteIca" options={optionsYesNo} required={true}
                                 defaultValue="N" label="Rete ICA" className={`${classResponsiveForm}`}
                                 customError={errors.reteIca ? ERRORFIELDREQUIRED : null}/>

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="reteIva" options={optionsYesNo} required={true}
                                 defaultValue="N" label="Rete IVA" className={`${classResponsiveForm}`}
                                 customError={errors.reteIva ? ERRORFIELDREQUIRED : null}/>

                <RadioButtonForm inputProps={{control}} disabled={!isEditing} identificador="reteFuente" options={optionsYesNo} required={true}
                                 defaultValue="N" label="Rete Fuente" className={`${classResponsiveForm}`}
                                 customError={errors.reteFuente ? ERRORFIELDREQUIRED : null}/>

            </div>


        </form>
        </FormProvider>
    )

}

export default FormPuntoVentaCRUD;
